/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { FCM } from '@capacitor-community/fcm';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Preferences } from '@capacitor/preferences';
import { FirebaseCrashlyticsService } from './firebase-crashlytics.service';


@Injectable({
  providedIn: 'root',
})
export class FcmService {
  private isNative: boolean = true;
  private firebasePlugin: any;
  constructor(
    public http: HttpClient,
    public alertCtrl: AlertController,
    public alertController: AlertController,
    private platform: Platform,
    public firebaseCrashlytics: FirebaseCrashlyticsService
  ) {
    console.log('Hello FcmService Provider');
    this.platform.ready().then(async () => {

    });
  }

  public getToken = async () => {
    if (!Capacitor.isNativePlatform()) {
      // If it's browser, returns.
      console.log('Not native platform, skipping FCM token retrieval');
      return;
    }

    this.platform.ready().then(async (_readySource) => {
      try {
        const status = PushNotifications.checkPermissions();
        if ((await status).receive != 'denied') {
          await PushNotifications.register();
          let token;

          FCM.setAutoInit({ enabled: true }).then(() => console.log("Auto init has been enabled "));

          FCM.getToken()
            .then(r => {
              token = r.token
              if (this.platform.is('android')) {
                this.saveTokenToDB(token, 'getTokenAndroid');
              }

              if (!this.platform.is('android')) {
                this.saveTokenToDB(token);
              }
            })
            .catch(err => console.log(err));

          FCM.refreshToken()
            .then(r => this.saveTokenToDB(r.token, 'onTokenRefresh'))
            .catch(err => {
              console.log(err)
            });
        }
      } catch (error) {
        console.error('Error in FCM getToken:', error);
      }
    });

    return;
  }

  private saveTokenToDB(token: string, _caller?: string) {
    if (token != null) {
      localStorage.setItem('TOKEN', token);
      Preferences.set({ key: 'TOKEN', value: token }).then((_val) => {
        console.log('token saved to DB');
      });
    }
  }

  async showModalAlert(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }

  public setUserIDtoCrashlytics(userData: any) {
    try {
      if (Capacitor.isNativePlatform()) {
        if (userData != undefined && userData != null && userData._id != null && userData?._id.$oid != null) {
          const reportId: string = userData?._id.$oid;
          console.log('Will set ID to Crashlytics: ' + reportId);

          this.firebaseCrashlytics.setEnabled(true).then(_res => {
            console.log("Crashlytics data collection is enabled");
          }, error => {
            console.error("Crashlytics data collection couldn't be enabled: " + error);
          });

          this.firebaseCrashlytics.setUserId(reportId)
          // this.firebasePlugin.setCrashlyticsUserId(reportId);
          // this.firebasePlugin.setUserId(reportId);

        }
      } else {
        console.log('Running on web platform, skipping Crashlytics setup');
      }
    } catch (error) {
      console.error('Error setting ID to crashlytics');
      console.error(error);
    }
  }

  getValue(_key: string): Promise<any> {
    return new Promise((_resolve, _reject) => {
      // this.firebasePlugin.getValue(key,
      //   (value: any) => resolve(value),
      //   (error:any) => reject(error)
      // );
    });
  }
}
